let apiUrl: string | undefined;
let frontendUrl: string | undefined;
const origin = typeof window !== 'undefined' ? window.location.origin : '';
if (origin === process.env.NEXT_PUBLIC_ACTIVE_OR_DEFAULT_SLOT_FRONTEND_URL) {
  apiUrl = process.env.NEXT_PUBLIC_ACTIVE_OR_DEFAULT_SLOT_API_URL;
  frontendUrl = process.env.NEXT_PUBLIC_ACTIVE_OR_DEFAULT_SLOT_FRONTEND_URL;
} else if (origin === process.env.NEXT_PUBLIC_PASSIVE_FRONTEND_URL) {
  apiUrl = process.env.NEXT_PUBLIC_PASSIVE_API_URL;
  frontendUrl = process.env.NEXT_PUBLIC_PASSIVE_FRONTEND_URL;
} else {
  console.warn('Unknown frontend origin, defaulting to active API');
  apiUrl = process.env.NEXT_PUBLIC_ACTIVE_OR_DEFAULT_SLOT_API_URL;
  frontendUrl = process.env.NEXT_PUBLIC_ACTIVE_OR_DEFAULT_SLOT_FRONTEND_URL;
}

const appConfig = {
  apiPrefix: apiUrl,
  tenantId: process.env.NEXT_PUBLIC_TENANT_ID,
  frontendUrl: frontendUrl,
  providerAuthenticatedEntryPath: '',
  customerAuthenticatedEntryPath: '',
  unAuthenticatedEntryPath: '',
};

export default appConfig;
